module.exports = __webpack_public_path__ + "static/media/open-in-window-hover.0c3d3f58.svg";